var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"bumpmap-logo"},[_c('img',{staticClass:"emblem",attrs:{"src":"/img/logo/emblem-dark.png","alt":"bumpmap"}}),_c('img',{staticClass:"logo-text",attrs:{"src":"/img/logo/bumpmap.svg","alt":"bumpmap"}})])}]

export { render, staticRenderFns }